import { render, staticRenderFns } from "./Bilderset.vue?vue&type=template&id=1723866a&scoped=true&"
import script from "./Bilderset.vue?vue&type=script&lang=js&"
export * from "./Bilderset.vue?vue&type=script&lang=js&"
import style0 from "./Bilderset.vue?vue&type=style&index=0&id=1723866a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1723866a",
  null
  
)

export default component.exports